export const MODAL_ANIMATION_DURATION = 300;
